import { render, staticRenderFns } from "./UpcomingAppointments.vue?vue&type=template&id=9509663e&scoped=true&"
import script from "./UpcomingAppointments.vue?vue&type=script&lang=js&"
export * from "./UpcomingAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9509663e",
  null
  
)

export default component.exports